/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export interface IHttpErrorHandler {

		id: string;

		handle: (result: angular.IHttpPromiseCallbackArg<any>) => angular.IPromise<any>;

		canHandle: (result: angular.IHttpPromiseCallbackArg<any>) => boolean;

	}

}